import { Grid, Link, Rating, Typography, useTheme } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import { useEffect, ReactNode } from 'react'
import { useBrand } from '../../utils/brand'
import { useLegalEntity } from '../../hooks/useLegalEntity'
import { legalMention } from '../../utils/legalEntities'
import EdumiamDrawer from './EdumiamDrawer'
import EdumiamHeader from './EdumiamHeader'
import IperiaAllRegistrationsLink from './IperiaAllRegistrationsLink'
import IperiaLotBanner from './IperiaLotBanner'
import type { IperiaFormType } from '../../utils/sharedTypes'

type EdumiamLayoutProps = {
  steps?: IperiaFormType['steps']
  children?: ReactNode
}

const EdumiamLayout = ({ steps, children}: EdumiamLayoutProps) => {
  const theme = useTheme()
  const brand = useBrand()
  const legalEntity = useLegalEntity(brand.id)
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <>
      <EdumiamDrawer steps={steps} />
      <Grid
        container
        sx={{
          minHeight: '100vh',
          justifyContent: {
            xs: 'start',
            sm: 'end',
          },
          alignContent: {
            xs: 'baseline',
            sm: 'normal',
          },
        }}
      >
        <EdumiamHeader steps={steps} />
        <Grid item xs={12} sm={8} md={9} sx={{ float: 'right', alignContent: 'right', justifySelf: 'right', p: 2 }}>
          <Grid
            sx={{
              display: { xs: 'none', sm: 'block' },
              position: 'fixed',
              top: 24,
              left: 324,
              zIndex: 2,
            }}
          >
            <IperiaAllRegistrationsLink />
          </Grid>
          <Grid item container justifyContent="center" sx={{ height: '100%', pt: { sm: 10 } }}>
            <Grid item xs={12} sm={8} md={7} sx={{ position: 'relative' }}>
              <IperiaLotBanner />
              {children || <Outlet />}
            </Grid>
            <Grid item xs={12} sm={8} md={7} sx={{ mt: 4, alignItems: 'flex-end', display: 'flex' }}>
              <Grid container direction="column">
                <Grid
                  item
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ display: { xs: 'flex', sm: 'none' } }}
                >
                  <Grid item>
                    <Typography variant="body2" sx={{ mr: 1 }}>
                      {brand.googleRating} sur Google
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Rating value={brand.googleRating} precision={0.1} readOnly sx={{ display: 'flex' }} />
                  </Grid>
                </Grid>
                <Grid item sx={{ mt: { xs: 4, md: 0 } }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: theme.palette.text.disabled,
                      fontSize: 12,
                      textAlign: { xs: 'center', md: 'left' },
                    }}
                  >
                    {legalMention(legalEntity, brand.name)} •{' '}
                    <Link href={`${brand.websiteUrl}/politique-de-confidentialite`} target="_blank">
                      Politique de confidentialité des Données
                    </Link>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default EdumiamLayout
